<template lang="pug">
  b-modal#editUser(
  ref="editUser"
  :title="$t('ui.combine.edit_user')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown")
    b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
      b-form-group(:label="$t('ui.id')").mb-3
        div.form-control.form-control-sm.disabled {{ getUserId }}
      b-form-group(:label="$t('ui.name')").mb-0
        DebounceInput(
          size="sm"
          ref="dataEdit_userName"
          required
          type="text"
          :dirty="$v.dataEdit_userName.$dirty"
          :error="$v.dataEdit_userName.$error"
          v-model.trim.lazy="$v.dataEdit_userName.$model"
          :disabled="loading"
          @focus.native="$event.target.select()"
          :maxLength="$v.dataEdit_userName.$params.maxLength.max"
        )
        ValidateResult(:value="$v.dataEdit_userName" :name="$t('ui.name')")
      div.row
        div.col
          b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
    div(slot="modal-cancel")
      SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  props: {
    userId: "",
    userName: ""
  },
  data() {
    return {
      dataEdit_userName: "",
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  computed: {
    getUserId: function() {
      return this.userId;
    }
  },
  validations: {
    dataEdit_userName: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(50)
    }
  },
  watch: {
    userName: function(newVal) {
      this.dataEdit_userName = newVal;
    }
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.editUserUrl();

        var json = {
          action_by: this.$store.getters.username,
          session_token: this.$store.getters.sessionToken,
          page_id: config.accessRoles.user,
          user_id: this.userId,
          user_name: this.dataEdit_userName
        };

        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = (typeof response.data.status == "string") ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked", this.userId, this.dataEdit_userName);
                  this.$refs.editUser.hide();
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  // this.$emit("failed", "edit_user", this.feedback.status);
                  // this.$refs.editUser.hide();
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
      this.dataEdit_userName = this.userName;
    },
    shown: function() {
      this.$v.$reset();
      this.$refs.dataEdit_userName.$el.focus();
    }
  }
};
</script>
